export const groupProductsByProduct = (products) => {

    const productGroups = {}
    
    products.forEach(product => {
        // Crea una clave única con descripción y satCode para agrupar los mismos productos de diferentes tickets
        const productKey = `${product.description}_${product.satCode}`
        
        if (!productGroups[productKey]) {
            productGroups[productKey] = {
                description: product.description,
                unitSat: product.unitSat,
                satCode: product.satCode,
                taxLabel: product.taxLabel || "NO",
                unitPrice: product.unitPrice,
                tickets: [],
                totalQuantity: 0,
                totalAmount: 0
            }
        }
        
        productGroups[productKey].tickets.push({
            ticketId: product.ticketId,
            ticketFolio: product.ticketFolio,
            quantity: product.quantity
        })
        
        productGroups[productKey].totalQuantity += product.quantity
        productGroups[productKey].totalAmount += product.total
    })
    return productGroups
}
